/**
 * Games Portal - Main entry point
 * Initializes the game modal and wires up interactions
 */

import { GameModal } from './GameModal';
import type { GameId } from './types';

class GamesPortal {
  private modal: GameModal;

  constructor() {
    this.modal = new GameModal();
    this.init();
  }

  private init(): void {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  private setup(): void {
    console.log('[Portal] Initializing games portal...');

    // Wire up game cards
    this.setupGameCards();

    // Update UI for any game status changes
    this.updateGameStatuses();

    console.log('[Portal] Games portal ready');
  }

  private setupGameCards(): void {
    const gameCards = document.querySelectorAll('.game-card');

    gameCards.forEach(card => {
      const gameId = card.getAttribute('data-game-id') as GameId | null;
      const playButton = card.querySelector('.play-button');

      if (gameId && playButton && !playButton.classList.contains('disabled')) {
        playButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.modal.open(gameId);
        });
      }
    });
  }

  private updateGameStatuses(): void {
    // Update Flappy Ellie card to show "Live" status
    const flappyCard = document.querySelector('[data-game-id="flappy-ellie"]');
    if (flappyCard) {
      // Update badge
      const badge = flappyCard.querySelector('.game-badge');
      if (badge) {
        badge.textContent = 'Live';
        badge.classList.add('live');
      }

      // Remove coming-soon class
      flappyCard.classList.remove('coming-soon');

      // Update preview filter
      const preview = flappyCard.querySelector('.game-preview') as HTMLElement;
      if (preview) {
        preview.style.filter = '';
      }

      // Update button
      const button = flappyCard.querySelector('.play-button');
      if (button) {
        button.classList.remove('disabled');
        (button as HTMLButtonElement).disabled = false;
        button.textContent = 'Play Now';
      }
    }
  }
}

// Initialize portal
new GamesPortal();

// Export for potential external use
export { GamesPortal };
